import { i18nLocizeInstance } from '@influitive/i18next-locize-launcher';

const i18nInstance = i18nLocizeInstance(
  process.env.LOCIZE_PROJECT_ID,
  process.env.LOCIZE_API_KEY,
  { defaultNs: 'HubFE', ns: 'HubFE' }
);

export default i18nInstance;



// WEBPACK FOOTER //
// ./src/localization.js